// extracted by mini-css-extract-plugin
export default {"table":"ReferralDocumentsTable_table__xJ3G4"};